import React, { useEffect, useRef } from 'react';
import {  useSelector } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';

import {
  CardOrder,
  Container,
  MainContainer
} from '~/components/layout/Logistic/styles';

import {
  CardInputItem,
  CloseIconStyled as IconStyled,
  PrintIconStyled,
  TextQuantity,
  TitlePage as IconsTop,
  Title,
} from './styles';

import '~/components/styles/Global.css';

import close from '~/assets/images/close.png';
import BodyPrevius from '~/components/pages/Logistic/PreviousDebt';
import OpenChatBot from '~/components/layout/Chatbot';
import Stepper from '~/components/layout/Logistic/StepperLine';
import PrinterIcon from '~/assets/images/printer.svg';
import { verifyRoles } from '~/utils/functions/verifyRoles';

export default function PreviousDebt() {
  const history = useHistory();
  const componentRef = useRef();

  const roles = useSelector(state => state.rolesReducer.roles);
  const logisticPaymentReducer = useSelector(state => state.logisticPaymentReducer);


  useEffect(() => {
    const interval = setInterval(() => {
      var iframes = document.querySelectorAll('iframe');
      for (var i = 0; i < iframes.length; i++) {
        if (iframes[i].id !== 'indecx-iframe') {
          iframes[i].parentNode.removeChild(iframes[i]);
        }
      }
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    var iframes = document.querySelectorAll('iframe');
    for (var i = 0; i < iframes.length; i++) {
      if (iframes[i].id !== 'indecx-iframe') {
        iframes[i].parentNode.removeChild(iframes[i]);
      }
    }
  }, [document]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(()=>{
    window.addEventListener('popstate', function() {
      history.replace('/portal')
    });
  },[])


  return (
    <Container>
      {verifyRoles(roles, 'PEDIDO_DE_ABASTECIMENTO') ? (
        <>
        <IconsTop>
          <IconStyled
            src={close}
            alt="Ícone de fechar"
            onClick={() => history.push('/lista-de-pedidos')}
          />
        </IconsTop>
        {logisticPaymentReducer?.order && (
          <CardOrder ref={componentRef}>
            <MainContainer>
              <Title>
                <span>Pedido</span>
                <PrintIconStyled
                  src={PrinterIcon}
                  alt="Ícone de voltar"
                  onClick={handlePrint}
                />
              </Title>
              <Stepper activeStep={7} steps={7} />
              <CardInputItem>
                <Row>
                  <Col>
                    <Row>
                      <TextQuantity>
                        Pedido: {logisticPaymentReducer.order.number}
                      </TextQuantity>
                    </Row>
                  </Col>
                </Row>
              </CardInputItem>
              <BodyPrevius
                dateAvailable={logisticPaymentReducer.order.expirationDate}
              />

            </MainContainer>
            <OpenChatBot backgroundColor={'#00f3ff'} />
          </CardOrder>
        )}
        </>
      ) : (
        <Redirect to="/portal" />
      )}
    </Container>
  );
}
